<template>
  <aside class="d-flex justify-content-center company-edit-menu">
    <div class="d-flex flex-column">
      <span class="link-wrapper">
        <span @click="setCompanyStep('companies-info')">
          <router-link :class="isActiveLinkClass('companies-info')" :to="`/companies/edit/${$route.params.id}?tab=companies-info`">
            Company info
          </router-link>
        </span>
      </span>
      <span class="link-wrapper">
        <span @click="setCompanyStep('companies-settings')">
          <router-link :class="isActiveLinkClass('companies-settings')" :to="`/companies/edit/${$route.params.id}?tab=companies-settings`">
            Company settings
          </router-link>
        </span>
      </span>
      <span class="link-wrapper">
        <span @click="setCompanyStep('companies-map')">
          <router-link :class="isActiveLinkClass('companies-map')" :to="`/companies/edit/${$route.params.id}?tab=companies-map`">
            Coverage
          </router-link>
        </span>
      </span>
      <span class="link-wrapper">
        <span @click="setCompanyStep('companies-pricing')">
          <router-link :class="isActiveLinkClass('companies-pricing')" :to="`/companies/edit/${$route.params.id}?tab=companies-pricing`">
            Pricing
          </router-link>
        </span>
      </span>
      <span class="link-wrapper">
        <span @click="setCompanyStep('companies-availability')">
          <router-link :class="isActiveLinkClass('companies-availability')" :to="`/companies/edit/${$route.params.id}?tab=companies-availability`">
            Availability
          </router-link>
        </span>
      </span>
      <span class="link-wrapper">
        <span @click="setCompanyStep('companies-email')">
          <router-link :class="isActiveLinkClass('companies-email')" :to="`/companies/edit/${$route.params.id}?tab=companies-email`">
            Email templates
          </router-link>
        </span>
      </span>
      <span class="link-wrapper">
        <span @click="setCompanyStep('web-quote')">
          <router-link
            :class="isActiveLinkClass('web-quote')"
            @click="setCompanyStep('web-quote')"
            v-if="$_can('companies.mod.update')"
            :to="`/companies/edit/${$route.params.id}?tab=web-quote`"
          >
            Web quote
          </router-link>
        </span>
      </span>
      <span class="link-wrapper">
        <span v-if="$_can('companies.mod.update')">
          <div id="headingCompanySubMenu" class="d-flex align-items-center">
            <a
              href="#"
              :class="{ collapsed: !mod24SettingsOpened }"
              data-toggle="collapse"
              data-target="#collapseCompanySubMenu"
              data-controls="#collapseCompanySubMenu"
              @click="mod24SettingsOpened = !mod24SettingsOpened"
            >
              Mod24 Settings
            </a>
            <div class="ml-3 pointer" @click="mod24SettingsOpened = !mod24SettingsOpened" :class="{'mod-icon-minus': mod24SettingsOpened, 'mod-icon-plus': !mod24SettingsOpened}" />
          </div>
        </span>
      </span>

      <div id="collapseCompanySubMenu" class="collapse" :class="{ show: mod24SettingsOpened }" aria-expanded="false" aria-labelledby="headingCompanySubMenu">
        <div class="accordion-sub-menu">
          <span class="link-wrapper">
            <span @click="setCompanyStep('getting-started')">
              <router-link
                :to="`/companies/edit/${$route.params.id}?tab=getting-started`"
                :class="isActiveLinkClass('getting-started')"
              >
                Getting started
              </router-link>
            </span>
          </span>
          <span class="link-wrapper">
            <span @click="setCompanyStep('companies-licence')">
              <router-link
                :to="`/companies/edit/${$route.params.id}?tab=companies-licence`"
                :class="isActiveLinkClass('companies-licence')"
              >
                Company Licence
              </router-link>
            </span>
          </span>
          <span class="link-wrapper">
            <span @click="setCompanyStep('companies-tier')">
              <router-link
                :to="`/companies/edit/${$route.params.id}?tab=companies-tier`"
                :class="isActiveLinkClass('companies-tier')"
              >
                Tier
              </router-link>
            </span>
          </span>
          <span class="link-wrapper">
            <span @click="setCompanyStep('website-details')">
              <router-link
                :to="`/companies/edit/${$route.params.id}?tab=website-details`"
                :class="isActiveLinkClass('website-details')"
              >
                Website Details
              </router-link>
            </span>
          </span>
          <span class="link-wrapper">
            <span @click="setCompanyStep('billing-info')">
              <router-link
                :to="`/companies/edit/${$route.params.id}?tab=billing-info`"
                :class="isActiveLinkClass('billing-info')"
              >
                Billing info
              </router-link>
            </span>
          </span>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'CompanyEditMenu',
  props: {
    step: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    mod24SettingsOpened: false,
  }),
  mounted() {
    const companyStep = this.$route.query.tab;
    if (companyStep) {
      this.mod24SettingsOpened =
        companyStep === 'getting-started' ||
        companyStep === 'companies-licence' ||
        companyStep === 'companies-tier' ||
        companyStep === 'website-details' ||
        companyStep === 'billing-info';
    }
  },
  methods: {
    ...mapMutations(['setCompany', 'setCompanyStep']),
    isActiveLinkClass(tabName) {
      if (
        (!this.$route.query.tab && tabName === 'companies-info') ||
        this.$route.query.tab === tabName
      ) {
        return 'active-link';
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.company-edit-menu {
  background-color: #eaeff5;
  margin-left: -15px;
  padding: 2rem;

  .link-wrapper {
    margin-top: 6px;
  }

  .router-link-active {
    width: 100%;
    height: 100% !important;
    display: inline-block;
  }

  a {
    color: #484f56 !important;
    text-transform: uppercase;
    margin: 10px;
    white-space: nowrap;
  }

  .active-link {
    color: #2961fd !important;
    font-weight: 500 !important;
  }

  .accordion-sub-menu {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
    margin-top: 10px;

    .link-wrapper {
      margin: 6px 5px 5px 10px;
    }

    a {
      color: #484f56 !important;
      text-transform: none;
      white-space: nowrap;
      font-size: 0.9rem;
      padding: 0 0 0 10px;
      border-left: 5px solid #e8edf3;
      height: 100% !important;
      margin: 0 !important;
    }

    .active-link {
      color: #2961fd !important;
      border-left: 5px solid #fdb200;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/companies/CompanyEditMenu.vue